import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './PackageDisplay.module.sass';
import { useHistory, useParams } from 'react-router';
import { CustomerContext } from '../../contexts/CustomerContext';
import Image from "../Image";
import defaultBackground from "../../assets/Package_Blue.png";
import Button from '../Button/v2';
import AbsolutePosImgs from '../_pages/AbsolutePosImgs/AbsolutePosImgs'
import Coupon from '../../models/Coupon';
import { routes } from "../../routes";
import axios from 'axios';
import useBuyAllOption from "../../hooks/useBuyAllOption";
import useLocalStorage from "../../hooks/useLocalStorage";
import useAddons from "../../hooks/useAddons";
import usePricelist from "../../hooks/usePricelist";

const usePcoupon = (packageId) => {
  const [coupon, setCoupon] = useState([]);

  useEffect(() => {
    Coupon
      .where({ packageId })
      .first()
      .then((res) => setCoupon(res.data));
  }, [packageId]);

  return coupon;
};

const PackageDisplay = ({ backgroundUrl, multiPoseHandler, orderPackage, isElementary,
                          studentImageUrl, option, price, imageTypes, currentOrderPackage, packageId, selectedPose, preorderPose }) => {
  const { package_id } = useParams();
  const history = useHistory();
  const { customer, setCustomer } = useContext(CustomerContext);
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const [couponValue, setCouponValue] = useState(0);
  const [priceInt, setPriceInt] = useState(0);
  const [salePrice, setSalePrice] = useState(0);

  const { data: pricelist } = usePricelist(packageId);
  const { data: buyAllOption, isLoading: isLoadingBuyAll } = useBuyAllOption(packageId, customer.currentSchool.id);
  const [currentSeason] = useLocalStorage(`currentSeason-${customer?.currentStudent?.id}`)
  const { data: addons } = useAddons(isElementary);


  const coupon = usePcoupon(packageId);

  useEffect(() => {
    if (coupon?._attributes)
      {
        setCouponValue(parseInt(coupon._attributes.value));
      }
  }, [coupon]);

  useEffect(() => {
    if (coupon?._attributes && price?.attributes)
      {
         const TcouponValue = parseFloat(coupon._attributes.value, 10);
         const TpriceInt = parseFloat(price._attributes.price, 10);
         const TsalePrice = TpriceInt * (100 - TcouponValue)/100;
         setSalePrice(TsalePrice.toFixed(2));
      }
  }, [coupon, price]);

  const handleContinue = async (optionId) => {
    if (optionId === buyAllOption?.id) {
      const response = await axios.post(`/carts/${customer?.cart?.id}/buy_all`,
        { package_id: packageId, option_id: buyAllOption.id, student_id: customer.currentStudent.id, season: currentSeason }
      );

      const orderPackageId = response.data?.order_package_id;

      if ([653, 654, 656, 656].includes(packageId)) return history.push(routes.confirm(orderPackageId))
      if (addons.length === 0 || !orderPackageId) return history.push(routes.review());

      history.push(routes.confirm(orderPackageId))
    } else {
      multiPoseHandler(optionId)
    }
  };

  if (!(option && price)) return null;
  if (isLoadingBuyAll) return null;

  return (
    <>
      <div className={styles.container} onClick={() => multiPoseHandler(option.id)}>
        <div className={styles.upperContainer}>
          <Image src={option.imageUrl.includes('missing') ? defaultBackground : option.imageUrl} alt="" classes={styles.packageImage} />
          {!preorderPose && !pricelist?.hideCss && AbsolutePosImgs(customer, packageId, option)}

        </div>

        <div className={styles.contentWrapper}>
          <div className={styles.packageDescriptionContainer}>
            <div className={styles.innerContainer}>
              <div>
                <p className={styles.description}>
                  {option.name}
                </p><br />
                <p className={styles.description2}>
                  {option.tagline}
                </p>
              </div>

              <div>
                <p className={ (packageId == 658   || packageId == 661 || packageId == 657  || packageId == 659 || packageId == 660  || packageId == 641  || packageId == 596 || packageId == 631  || packageId == 611 || packageId == 614 || packageId == 615 || packageId == 616 || packageId == 603 || packageId == 622 || packageId == 625 || packageId == 626 || packageId == 627 || packageId == 628 || packageId == 565 || packageId == 666 || packageId == 667 || packageId == 578 || packageId == 636 || packageId == 637 || packageId == 638 || packageId == 639  || packageId == 640 ) && salePrice ? styles.price : styles.saleprice}>
                  {price.price ? `$${price.price.toString()}` : '$0'}
                </p>
                <p className={ (packageId == 658  || packageId == 661 || packageId == 657 || packageId == 659 || packageId == 660  || packageId == 641 || packageId == 596 || packageId == 631 || packageId == 611 || packageId == 614 || packageId == 615 || packageId == 616|| packageId == 603 || packageId == 622 || packageId == 625 || packageId == 626 || packageId == 627 || packageId == 628 || packageId == 565 || packageId == 666 || packageId == 667 || packageId == 578 || packageId == 636 || packageId == 637 || packageId == 638 || packageId == 639  || packageId == 640)  ? styles.saleprice : styles.salepricehidden}>
                  
                  {salePrice ? `$${salePrice.toString()}` : ''}
                  
                </p>
              </div>
            </div>
          </div>

          <div className={styles.packageContents}>
            <p className={styles.packageText}>
              {option.description}
            </p>
          </div>
          <Button
            className={styles.btn}
            onClick={() => handleContinue(option.id)}
          >
            Select
          </Button>
        </div>
      </div>
    </>
  );
};

PackageDisplay.defaultProps = {
  imageTypes: [],
  multiPose: null,
};

PackageDisplay.propTypes = {
  backgroundUrl: PropTypes.string,
  studentImageUrl: PropTypes.string,
  multiPose: PropTypes.func,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    abbreviation: PropTypes.string,
    poses: PropTypes.number,
    slug: PropTypes.string,
    name: PropTypes.string.isRequired,
    bestValue: PropTypes.bool.isRequired,
    additionalPoseCharge: PropTypes.number,
    download: PropTypes.bool.isRequired,
    emailPicture: PropTypes.bool.isRequired,
    superValue: PropTypes.bool.isRequired,
    without: PropTypes.bool.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  }),
  imageTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  price: PropTypes.shape({
    id: PropTypes.string.isRequired,
    begin: PropTypes.string,
    enddate: PropTypes.string,
    price: PropTypes.number.isRequired,
    createdAt: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
  })
};

export default PackageDisplay;
